/* eslint-disable func-style */
define([
    '../slide'
], function (SlideComponent) {
   'use strict';

   return SlideComponent.extend({
       defaults: {
           currentSlide: null
       },

       attachElement: function (groupEl) {
           this._super(groupEl);

           const children = Array.from(groupEl.children);
           const menuHeightAccommodation = getComputedStyle(groupEl).getPropertyValue('--ft-menu-height-adjust');

           children.forEach(
               (child, childIdx) => {
                   const endExp = childIdx === children.length - 1 ? 'bottom bottom' : 'bottom top';
                   const mediaContainer = child.querySelector('.media-container');
                   this.ScrollTrigger.create({
                       trigger: child,
                       toggleClass: 'media-container-pinned',
                       pin: mediaContainer,
                       start: () => `top-=${menuHeightAccommodation} top`,
                       end: () => endExp
                   });

                   if (childIdx > 0) {
                       this.gsap.from(mediaContainer, {
                           autoAlpha: 0,
                           scrollTrigger: {
                               ease: 'none',
                               trigger: child,
                               start: () => 'top top',
                               end: () => 'top -25%',
                               scrub: true
                           }
                       });
                   }
               }
           );
       },

       /**
        * @returns {Object} extended config
        */
       getScrollTriggerConfig: function () {
           return Object.assign({}, this._super(), {
               toggleClass: 'crossfade-active',
               start: 'top top',
               end: 'bottom bottom'
           });
       }
   });
});
